// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"271edec3","41":"7f105b51","307":"4dd4dd11"}[chunkId] + ".chunk.js";
};